export default {
    PENDENTE: 1,
    RESPONDIDA: 2,
    FINALIZADA: 3,
}